// extracted by mini-css-extract-plugin
module.exports = {"map_avatar":"styles-module__map_avatar___3Ga_i","robot_shadow":"styles-module__robot_shadow___8s4m_"};